import React from 'react';
import styled from 'styled-components';
import { COLOR, SIZE } from '../../utils/constants.js';
import TextIcon from '../atoms/texticon.jsx';

import PathIcBullet3 from '../../icons/ic_bullet3.svg';
import PathIcBullet4 from '../../icons/ic_bullet4.svg';


const Container = styled.div`
    margin: ${props => props.margin ? props.margin : ''};
`;

const BulletListContent = styled.ul`
    overflow: auto;  // To avoid ul content outside of div.
`

const BulletItemContent = styled.li`
    float: left;
    clear: left;
 `;

const Bullets = ({
     margin,
     item_text_size = SIZE.title,
     item_text_color = COLOR.black,
     item_bullet_ic_path = PathIcBullet3,
     ic_bullet_size,
     font_family,
     items,
     subitem_bullet_ic_path = PathIcBullet4,
     subitem_text_size = SIZE.title,
     subitem_text_color = COLOR.black
}) => {

     const itemsLi = items?.map((bullet, index) => {
          if (bullet.subitems && bullet.subitems.length > 0) {
               const subitemsLi = bullet.subitems?.map((subitem, subindex) => 
                    <BulletItemContent
                         key={subindex}>
                         <TextIcon
                              key={subindex}
                              ic_path={subitem_bullet_ic_path}
                              ic_size='10px'
                              ic_color={COLOR.black}
                              text_color={subitem_text_color}
                              text_size={subitem_text_size}
                              font_family={font_family}
                              valign={false}
                              margin='6px 0 0 80px'>
                              {subitem}
                         </TextIcon>
                    </BulletItemContent>
               );
               return (
                    <BulletItemContent
                         key={index}>
                         <TextIcon
                              key={index}
                              ic_path={item_bullet_ic_path}
                              ic_size='10px'
                              ic_color={COLOR.ferra}
                              ic_top='9px'
                              text_color={item_text_color}
                              text_size={item_text_size}
                              font_family={font_family}
                              valign={false}
                              margin='15px 0 0 0'>
                              {bullet.item}
                         </TextIcon>
                         <BulletListContent> {subitemsLi} </BulletListContent>
                    </BulletItemContent>
               )
          }
          else {
               return (
                    <BulletItemContent
                         key={index}>
                         <TextIcon
                              key={index}
                              ic_path={item_bullet_ic_path}
                              ic_size='10px'
                              ic_color={COLOR.ferra}
                              ic_top='9px'
                              text_color={item_text_color}
                              text_size={item_text_size}
                              font_family={font_family}
                              valign={false}
                              margin='12px 0 0 0'>
                              {bullet.item}
                         </TextIcon>
                    </BulletItemContent>
               )
          }
     });

     return (
     <Container
          margin={margin}>
          <BulletListContent>{itemsLi}</BulletListContent>
     </Container>)
}

export default Bullets;